import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm gz-fade-up">
        {sent ? (
          <div className="text-center">
            <MailCheck className="mx-auto h-10 w-10 text-[#166534]" />
            <h2 className="mt-4 font-heading text-xl font-bold text-slate-900">Controlla la tua email</h2>
            <p className="mt-2 text-sm text-slate-500">
              Se l'email è registrata, riceverai un link per reimpostare la password.
            </p>
            <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-sm text-[#166534] hover:underline">
              <ArrowLeft className="h-4 w-4" /> Torna all'accesso
            </Link>
          </div>
        ) : (
          <>
            <h2 className="font-heading text-2xl font-bold text-slate-900">Recupera password</h2>
            <p className="mt-1 text-sm text-slate-500">Ti invieremo un link per reimpostarla.</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  data-testid="forgot-email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              {error && <p className="text-sm text-red-700">{error}</p>}
              <Button type="submit" disabled={loading} data-testid="forgot-submit-button" className="w-full bg-[#14382C] hover:bg-[#0E281F]">
                {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                Invia link
              </Button>
              <div className="text-center">
                <Link to="/login" className="inline-flex items-center gap-2 text-sm text-[#166534] hover:underline">
                  <ArrowLeft className="h-4 w-4" /> Torna all'accesso
                </Link>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
